import React from "react";
import { Link } from "react-router-dom";

const ClusteringPage = () => {
  return (
    <section className="subpage-section">
      <div className="container">
        <h1 className="subpage-title">Clustering</h1>
        <p className="subpage-body">
          Organize reads, identify patterns, and surface cluster-level insights
          with cloud-native clustering workflows.
        </p>
        <div className="subpage-visual">
          <div className="subpage-visual-media">
            Placeholder image: cluster map with labeled groups
          </div>
          <div className="subpage-visual-notes">
            <h2>What is most useful on this page</h2>
            <ul>
              <li>Cluster scatter/UMAP visual with clear group separation.</li>
              <li>
                Interactive filter panel showing metadata-driven exploration.
              </li>
              <li>Export-ready summary table for downstream reporting.</li>
            </ul>
          </div>
        </div>
        <div className="subpage-feature-grid">
          <div className="subpage-feature-card">
            <div className="subpage-card-image-placeholder">
              Placeholder: unsupervised cluster discovery graphic
            </div>
            <h3>Cluster Discovery</h3>
            <p>
              Detect distinct sequence groups and explore biological signal at
              scale.
            </p>
            <Link to="/resources#guides" className="read-more-link">
              Read more
            </Link>
          </div>
          <div className="subpage-feature-card">
            <div className="subpage-card-image-placeholder">
              Placeholder: basecalling-to-clustering handoff view
            </div>
            <h3>Integrated with Basecalling</h3>
            <p>
              Move directly from basecalling outputs into clustering without
              fragile manual handoffs.
            </p>
            <Link to="/product/basecalling" className="read-more-link">
              Read more
            </Link>
          </div>
          <div className="subpage-feature-card">
            <div className="subpage-card-image-placeholder">
              Placeholder: team review and annotation snapshot
            </div>
            <h3>Team-ready Outputs</h3>
            <p>
              Share cluster summaries and exports with collaborators for rapid
              interpretation.
            </p>
            <Link to="/product/tools" className="read-more-link">
              Read more
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClusteringPage;
